export const ERROR_IMAGE_URL = `${process.env.REACT_APP_ASSETS_IMAGES_URL}/error.svg`;

export default ERROR_IMAGE_URL;